import React, { Component, PropTypes } from 'react'
import { Link } from 'react-router'

import './Success.scss'
import successImg from './images/confirmacionAgendarAliada.png'
import searching from './images/searching.png'
import * as localStorage from 'utils/localStorage'
import * as paths from 'utils/paths'

import moment from 'moment-timezone'
import { TIMEZONE } from '@src/globals'

import { LogOnMount } from '@amplitude/react-amplitude'
import { URGENT_ALIADA_ID } from '@src/globals'

class Success extends Component {
  componentDidMount () {
    this.removePromoCode()
  }

  removePromoCode () {
    localStorage.removeItem('aliada_promoCode')
  }

  is_posible_to_deliver_the_kit () {
    const { serviceDate, serviceTime } = this.props;

    const datetime = moment.tz(`${serviceDate} ${serviceTime}`, TIMEZONE);
    const nextDay = moment().add(1, 'days');
    const isAfterYesterday = moment(datetime).isAfter(nextDay);
    const day = moment(datetime).day();
    const isWeekend = (day === 6) || (day === 0);

    return (!isWeekend && isAfterYesterday);
  }

  buyConfirmation (e) {
    if (!window.confirm("Confirmar compra")) {
      e.preventDefault()
    }
  }

  render () {
    const {
      aliada,
      bookingId,
      serviceTypeId,
      params: {
        userId
      }
    } = this.props

    const instructionsUrl = paths.aliadaReserveInstructions(aliada.id, {
      bookingId,
      serviceTypeId
    })

    const isUrgentService = aliada.id == URGENT_ALIADA_ID

    if (isUrgentService) {
      return (
        <div className='Success-content navbar-screen-content'>
          <LogOnMount eventType='successful-booking-screen' />
          <div className='navbar-screen-container'>
            <a href={paths.userNextServices(userId)} className='boxclose'>x</a>
            <img src={searching} />
            <div style={{margin: 23}}>
              <h1 style={{textAlign: 'left'}}>
                PUNTOS IMPORTANTES
              </h1>
              <p style={{textAlign: 'left', margin: 10}}>
                <li>Estamos buscando una aliada disponible.</li>
              </p>
              <p style={{textAlign: 'left', margin: 10}}>
                <li>Te contactaremos en <b>20 minutos</b> para confirmar tu servicio.</li>
              </p>
              <p style={{textAlign: 'left', margin: 10}}>
                <li>Hasta que recibas la confirmación, procesaremos tu pago.</li>
              </p>
            </div>
          </div>
        </div>
      )
    } else {
      return (
        <div className='Success-content navbar-screen-content'>
          <LogOnMount eventType='successful-booking-screen' />
          <div className='navbar-screen-container'>
            <a href={paths.userNextServices(userId)} className='boxclose'>x</a>
            <h1>
              Felicidades
            </h1>
            <span>
              tu servicio con {aliada.firstName} quedó agendado
            </span>
            <img src={successImg} />
            <Link to={instructionsUrl}>¿Necesitas dejar instrucciones a {aliada.firstName}?</Link>
          </div>
        </div>
      )
    }
  }
}
Success.displayName = 'Success'
Success.propTypes = {
  aliada: PropTypes.shape({
    id: PropTypes.string.number,
    firstName: PropTypes.string.isRequired
  }).isRequired
}
Success.defaultProps = {}

export default Success



// WEBPACK FOOTER //
// ./src/screens/App/screens/Booking/screens/Success/Success.js